import React from 'react';
import { Component } from "react";
import { API_URL } from '../urls';
import {Form} from "react-bootstrap";
import {Button} from "react-bootstrap";
import DefaultLayout from "../layouts/Default";
import { Editor } from '@tinymce/tinymce-react';
require('odatajs');

class ProductPageEdit extends Component {
  constructor(props) {
    super(props);
    this.state = {
      error: null,
      pending: true,
      params: props.match.params,
      data: null
    };
  }

  componentDidMount() {
    document.title = "Edit product page";
    let token = localStorage.getItem('_TOKEN_AUTH');
    var headers = { 'Content-Type': 'application/json', Accept: 'application/json', Authorization: "Bearer " + token };
    var request = {
      requestUri: API_URL + "Products?$filter=Name eq '" + encodeURIComponent(this.state.params.product_name) + "'"
      + "&$expand=Pages($filter=Name eq '" + encodeURIComponent(this.state.params.page_name) + "')",
      method: 'GET',
      headers: headers
  };
  window.odatajs.oData.request(
    request,
    (data, response) => {
        this.setState({
          pending: false,
          data
    });
        },
        (error) => {
            if(error.response.statusCode === 401){
              window.location.href = "/user/login";
            }
        this.setState({
          pending: false,
          error
      });
        }
    );
  }

  save(e) {
    e.preventDefault();
    let data = this.state.data;
    data.value[0].Pages[0].Body = this.state.editor.getContent();
    this.setState({ data });

    let token = localStorage.getItem('_TOKEN_AUTH');
    var headers = { 'Content-Type': 'application/json', Accept: 'application/json', Authorization: "Bearer " + token };
    var request = {
        requestUri: API_URL + "Products(" + this.state.data.value[0].Id + ")/Pages(" + this.state.data.value[0].Pages[0].Id + ")",
        method: 'PUT',
        headers: headers,
        data: {
          "@odata.type":"#IVySoft.SiteBuilder.Products.Model.ProductPage",
          ...this.state.data.value[0].Pages[0]
        }
    };
    window.odatajs.oData.request(
        request,
        (data, response) => {
          window.location.href = "/product/" + this.state.params.product_name + "/" + this.state.params.page_name; 
        },
        (err) => {
            alert('Fail: ' + err.message);
        }
    );    
  }

    render() { 
	const { error, pending } = this.state;
	if (error) {
      		return <div>Error: {error.message}</div>;
	} else if (pending) {
		return <div>Loading...</div>;
	} else {
	        return (
<DefaultLayout>
<Form onSubmit={(e) => this.save(e)}>
  <Form.Group>
    <Form.Label htmlFor="">Product page name</Form.Label>
    <Form.Control
      type="text" id="" placeholder="Enter unique name of product name" aria-describedby="HelpBlock"
      value={this.state.data.value[0].Pages[0].Name} onChange={(e) => { let data = this.state.data; data.value[0].Pages[0].Name = e.target.value; this.setState({ data });}}
    />
    <Form.Text id="HelpBlock" muted>Unique product page name</Form.Text>
  </Form.Group>
  <Form.Group>
    <Form.Label htmlFor="">Title</Form.Label>
    <Form.Control
      type="text" id="" placeholder="Enter title for this page" aria-describedby="HelpBlock"
      value={this.state.data.value[0].Pages[0].Title} onChange={(e) => { let data = this.state.data; data.value[0].Pages[0].Title = e.target.value; this.setState({ data });}}
    />
    <Form.Text id="HelpBlock" muted>Brower window title</Form.Text>
  </Form.Group>
  <Form.Group>
    <Form.Label htmlFor="">Page body</Form.Label>
    <Editor
         initialValue="<p>This is the initial content of the editor</p>"
         init={{
           height: 500,
           menubar: true,
           plugins: [
             'advlist autolink lists link image charmap print preview anchor',
             'searchreplace visualblocks code fullscreen',
             'insertdatetime media table contextmenu paste code help wordcount'
           ],
           toolbar:
             'undo redo | formatselect | bold italic backcolor | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent | removeformat | help',
           image_title: true,
           automatic_uploads: true,
           file_picker_types: 'image',
           paste_data_images:true,
           file_picker_callback: function (cb, value, meta) {
              var input = document.createElement('input');
              input.setAttribute('type', 'file');
              input.setAttribute('accept', 'image/*');

              input.onchange = function () {
                var file = this.files[0];

                var reader = new FileReader();
                reader.onload = function () {
                  /*
                    Note: Now we need to register the blob in TinyMCEs image blob
                    registry. In the next release this part hopefully won't be
                    necessary, as we are looking to handle it internally.
                  */
                  var id = 'blobid' + (new Date()).getTime();
                  var blobCache =  this.state.editor.editorUpload.blobCache;
                  var base64 = reader.result.split(',')[1];
                  var blobInfo = blobCache.create(id, file, base64);
                  blobCache.add(blobInfo);

                  /* call the callback and populate the Title field with the file name */
                  cb(blobInfo.blobUri(), { title: file.name });
                };
                reader.readAsDataURL(file);
              };

              input.click();
            }
         }}
         onInit={(e, editor) => this.setState({editor})}         
         value={this.state.data.value[0].Pages[0].Body}
         //onChange={(e) => { let data = this.state.data; data.value[0].Pages[0].Body = e.target.getContent(); this.setState({ data });}}
       />
       <Form.Text id="HelpBlock" muted>Specify page body</Form.Text>

  </Form.Group>
<Button type="submit">Save</Button>

</Form>
</DefaultLayout>
		);
	}
    }
}
 
export default ProductPageEdit;